import React from 'react';
import ReactPaginate from 'react-paginate';


const Pagination = ({handlePageClick, pageCount}) => {
    return (
        <div className="row">
            <div className="col-md-12">
                <ReactPaginate
                        previousLabel={<i className="fa fa-angle-double-left"></i>}
                        nextLabel={<i className="fa fa-angle-double-right"></i>}
                        breakLabel={'...'}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        containerClassName={'pagination'}
                        subContainerClassName={'pages pagination'}
                        activeClassName={'paginate_button page-item active'}
                        activeLinkClassName={'active page-link'}
                        previousClassName={'paginate_button page-item previous'}
                        previousLinkClassName={'page-link'}
                        nextClassName={'paginate_button page-item next'}
                        nextLinkClassName={'page-link'}
                        pageClassName={'paginate_button page-item'}
                        pageLinkClassName={'page-link'}
                    />
            </div>
        </div>
    );
}

export default Pagination